/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// select example
class Select extends Component {
  // state = {
  //   selectedIdx: this.props.selectedIdx,
  // };

  handleSelectChange = evt => {
    // this.setState({ selectedIdx: evt.target.selectedIndex });
    this.props.onSelectChange(evt.target.selectedIndex);
  };
  render() {
    const selects = this.props.options.map(op => (
      <option key={op} >{op}</option>
    ));

    return (
      <select
        value={this.props.options[this.props.selectedIdx]}
        onChange={this.handleSelectChange}
        // onChange={this.props.action.bind(null, this.value)}
        className={`${styles.input} ${styles.select}`}
      >
        {selects}
      </select>
    );
  }
}

export default Select;
